import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_PETITION_KICKSTART_TOGGLE = defineFcm('starfish_petition_kickstart_toggle')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig({
		owner: 'squad-starfish',
		scope: ['comms-stack', 'corgi-front-end'],
		context: 'Petition Free Promotion Kickstart',
		description:
			'Feature toggle for the petition kickstart UI in the starter onboarding flow that is tied to an experiment `petitionKickstartToggle`',
		mergeLogic: 'Needs combination of both country code and locale to be enabled',
		import: false,
	});
